// extracted by mini-css-extract-plugin
export default {"container":"OrderTotal_container__aAQ3+","total":"OrderTotal_total__EArpo"};